import React, {Component} from 'react'
import PropTypes from 'prop-types'
import HistoryRow from "./HistoryRow"

class HistoryBody extends Component {
    _renderHistoryItem = () => {
        const {loading, listHistories, error} = this.props

        if (error) {
            return <tr>
                <td colSpan={6}><span className='text-danger'>{error}</span>
                </td>
            </tr>
        }

        if (loading && listHistories.length <= 0) {
            return <tr>
                <td colSpan={6}>Loading ...</td>
            </tr>
        }

        return listHistories.length > 0 && listHistories.map((item, index) => {
            return <HistoryRow key={item._id} item={item} index={index}/>
        })
    }

    render() {
        return (
            <tbody className='HistoryBody'>
            {this._renderHistoryItem()}
            </tbody>
        )
    }
}

HistoryBody.propTypes = {
    loading: PropTypes.bool,
    error: PropTypes.string,
    listHistory: PropTypes.array
}

export default HistoryBody